/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentExportTypeFilters.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Export Type Filter API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Tuesday, December 10, 2019 - 09:25:27 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      12/10/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const ExportTypeFilters = {
    all: (exporttypeid) => requests.get(`/ExportTypeFilters?exporttypeid=${exporttypeid}`),
    get: exporttypefilterid => requests.get(`/ExportTypeFilter/${exporttypefilterid}`),
    create: exporttypefilter => requests.post(`/ExportTypeFilters`, exporttypefilter),
    update: (exporttypefilterid, exporttypefilter) => requests.put(`/ExportTypeFilter/${exporttypefilterid}`, exporttypefilter),
    delete: (exporttypefilterid, exporttypefilter) => requests.del(`/ExportTypeFilter/${exporttypefilterid}`, exporttypefilter),
};


// WEBPACK FOOTER //
// ./src/agents/agentExportTypeFilters.js